module.exports = __webpack_public_path__ + "assets/img/29_211.05ddb7f5.jpg";